/***** COMMON *****/
export const SET_IS_LOADING = "SET_IS_LOADING";
export const OPEN_DISCARD_DIALOG = "OPEN_DISCARD_DIALOG";
export const CLOSE_DISCARD_DIALOG = "CLOSE_DISCARD_DIALOG";

/***** TABS *****/
export const UPDATE_CURRENT_TAB = "UPDATE_CURRENT_TAB";
export const START_FLOW_EXECUTION = "START_FLOW_EXECUTION";
export const STOP_FLOW_EXECUTION = "STOP_FLOW_EXECUTION";
export const SAVE_FLOW_TABS = "SAVE_FLOW_TABS";
export const SET_ACTIVE_FLEXLAYOUT_TAB = "SET_ACTIVE_FLEXLAYOUT_TAB";

/***** FLOWS *****/
export const FETCH_FLOW_BY_ID = "FETCH_FLOW_BY_ID";
export const SET_FLOW_BY_ID = "SET_FLOW_BY_ID";
export const DUPLICATE_FLOW = "DUPLICATE_FLOW";
export const UPDATE_CURRENT_FLOW = "UPDATE_CURRENT_FLOW";
export const AUTO_CREATE_NEW_FLOW = "AUTO_CREATE_NEW_FLOW";
export const AUTO_UPDATE_CURRENT_FLOW = "AUTO_UPDATE_CURRENT_FLOW";
export const SET_SAVED_FLOW = "SET_SAVED_FLOW";

export const SET_SAVING_FLOW_FLAG_SUCCESS = "SET_SAVING_FLOW_FLAG_SUCCESS";
export const SET_SAVING_FLOW_FLAG_RESET = "SET_SAVING_FLOW_FLAG_RESET";
export const SET_AUTO_SAVING_FLOW_FLAG_SUCCESS = "SET_AUTO_SAVING_FLOW_FLAG_SUCCESS";
export const SET_AUTO_SAVING_FLOW_FLAG_RESET = "SET_AUTO_SAVING_FLOW_FLAG_RESET";
export const SET_SAVING_FLOW_PROPERTIES_FLAG_RESET = "SET_SAVING_FLOW_PROPERTIES_FLAG_RESET";
export const SET_SAVING_FLOW_PROPERTIES_FLAG_SUCCESS = "SET_SAVING_FLOW_PROPERTIES_FLAG_SUCCESS";
export const CLEAR_CURRENT_SAVED_FLOW = "CLEAR_CURRENT_SAVED_FLOW";
export const CLEAR_FLOW = "CLEAR_FLOW";
export const CREATE_NEW_FLOW_PROPERTIES = "CREATE_NEW_FLOW_PROPERTIES";
export const UPDATE_CURRENT_FLOW_PROPERTIES = "UPDATE_CURRENT_FLOW_PROPERTIES";
export const SET_FLOW = "SET_FLOW";
export const UPDATE_FLOW_STEPS = "UPDATE_FLOW_STEPS";
export const SET_CANVAS_FLOW_INSTANCE = "SET_CANVAS_FLOW_INSTANCE";
export const RELOAD_FLOW = "RELOAD_FLOW";
export const UPDATE_FLOW_THUMBNAIL = "UPDATE_FLOW_THUMBNAIL";

export const AUTO_SAVE_ON_CANCEL_RESET = "AUTO_SAVE_ON_CANCEL_RESET";
export const START_DRAG_COMPONENT = "START_DRAG_COMPONENT";
export const STOP_DRAG_COMPONENT = "STOP_DRAG_COMPONENT";
export const OPEN_FLOW_LIST_DIALOG = "OPEN_FLOW_LIST_DIALOG";
export const CLOSE_FLOW_LIST_DIALOG = "CLOSE_FLOW_LIST_DIALOG";
export const OPEN_RECENT_ACTIVITIES_DIALOG = "OPEN_RECENT_ACTIVITIES_DIALOG";
export const CLOSE_RECENT_ACTIVITIES_DIALOG = "CLOSE_RECENT_ACTIVITIES_DIALOG";
export const SET_NEW_TAB_FLAG = "SET_NEW_TAB_FLAG";
export const SHARE_DESIGNER_FLOW = "SHARE_DESIGNER_FLOW";
export const UPDATE_SHARE_FLOW = "UPDATE_SHARE_FLOW";
export const UNSHARE_FLOW = "UNSHARE_FLOW";
export const SET_SHARE_FLOW_FLAG_RESET = "SET_SHARE_FLOW_FLAG_RESET";
export const SET_SHARE_FLOW_FLAG_SUCCESS = "SET_SHARE_FLOW_FLAG_SUCCESS";
export const SET_SCHEDULED_FLOW_FLAG = "SET_SCHEDULED_FLOW_FLAG";
export const ADD_FLOW_VARIABLE = "ADD_FLOW_VARIABLE";
export const UPDATE_FLOW_VARIABLE = "UPDATE_FLOW_VARIABLE";
export const DELETE_FLOW_VARIABLE = "DELETE_FLOW_VARIABLE";
export const SET_FLOW_VARIABLES = "SET_FLOW_VARIABLES";
export const OPEN_DUPLICATE_FLOW_DIALOG = "OPEN_DUPLICATE_FLOW_DIALOG";
export const CLOSE_DUPLICATE_FLOW_DIALOG = "CLOSE_DUPLICATE_FLOW_DIALOG";
export const SET_NUMBER_OF_NODES_LIMIT_REACHED = "SET_NUMBER_OF_NODES_LIMIT_REACHED";
export const SET_COPIED_NODE = "SET_COPIED_NODE";
export const SET_CUT_NODE = "SET_CUT_NODE";
export const SET_IS_NOTES_DIALOG_OPEN = "SET_IS_NOTES_DIALOG_OPEN";
export const SET_NODE_TO_ADD_NOTES = "SET_NODE_TO_ADD_NOTES";
export const SET_DRAGGED_NODE = "SET_DRAGGED_NODE";
export const FETCH_USER_COMMENTS = "FETCH_USER_COMMENTS";
export const SET_USER_COMMENTS = "SET_USER_COMMENTS";
export const SET_IS_LOADING_USER_COMMENTS = "SET_IS_LOADING_USER_COMMENTS";
export const FETCH_DESIGNER_USER_FLOWS = "FETCH_DESIGNER_USER_FLOWS";
export const FETCH_DESIGNER_FLOWS = "FETCH_DESIGNER_FLOWS";
export const SET_DESIGNER_USER_FLOWS = "SET_DESIGNER_USER_FLOWS";
export const UPSERT_DESIGNER_USER_FLOWS = "UPSERT_DESIGNER_USER_FLOWS";
export const REMOVE_DESIGNER_USER_FLOWS = "REMOVE_DESIGNER_USER_FLOWS";
export const SET_DESIGNER_FLOWS = "SET_DESIGNER_FLOWS";
export const SET_FLOW_IS_LOADING = "SET_FLOW_IS_LOADING";
export const RELOAD_FLOWS = "RELOAD_FLOWS";

/***** FLOW VERSIONS *****/
export const FETCH_FLOW_VERSIONS = "FETCH_FLOW_VERSIONS";
export const SET_FLOW_VERSIONS = "SET_FLOW_VERSIONS";
export const SET_FLOW_VERSIONS_IS_LOADING = "SET_FLOW_VERSIONS_IS_LOADING";
export const UPDATE_FLOW_VERSION = "UPDATE_FLOW_VERSION";
export const SWITCH_FLOW_EDIT_MODE = "SWITCH_FLOW_EDIT_MODE";
export const CHANGE_FLOW_MODE = "CHANGE_FLOW_MODE";
export const VIEW_FLOW_VERSION = "VIEW_FLOW_VERSION";
export const SET_FLOW_VERSIONS_DIALOG_OPEN = "SET_FLOW_VERSIONS_DIALOG_OPEN";
export const SET_CREATE_FLOW_VERSION_DIALOG_OPEN = "SET_CREATE_FLOW_VERSION_DIALOG_OPEN";
export const SET_DELETE_FLOW_VERSION_DIALOG_OPEN = "SET_DELETE_FLOW_VERSION_DIALOG_OPEN";
export const SET_FLOW_VERSION_TO_DELETE = "SET_FLOW_VERSION_TO_DELETE";
export const SET_CHANGE_FLOW_VERSION_DIALOG_OPEN = "SET_CHANGE_FLOW_VERSION_DIALOG_OPEN";
export const SET_FLOW_VERSION_TO_USE = "SET_FLOW_VERSION_TO_USE";
export const SET_IS_CHANGING_FLOW_MODE = "SET_IS_CHANGING_FLOW_MODE";

/***** FLOW EXECUTION *****/
export const EXECUTE_FLOW = "EXECUTE_FLOW";
export const SET_FLOW_EXECUTION_FAILED = "SET_FLOW_EXECUTION_FAILED";
export const SET_FLOW_EXECUTION_FAILED_RESET = "SET_FLOW_EXECUTION_FAILED_RESET";
export const ADD_EXECUTION_REPORT = "ADD_EXECUTION_REPORT";
export const FILTER_AND_ADD_EXECUTION_REPORT = "FILTER_AND_ADD_EXECUTION_REPORT";
export const SHOW_FLOW_USAGE_DIALOG = "SHOW_FLOW_USAGE_DIALOG";
export const HIDE_FLOW_USAGE_DIALOG = "HIDE_FLOW_USAGE_DIALOG";
export const CANCEL_FLOW_EXECUTION = "CANCEL_FLOW_EXECUTION";
export const FETCH_EXECUTION_LOGS_FLOW_SCHEDULE = "FETCH_EXECUTION_LOGS_FLOW_SCHEDULE";
export const FETCH_EXECUTION_LOGS = "FETCH_EXECUTION_LOGS";
export const SET_EXECUTION_LOGS = "SET_EXECUTION_LOGS";
export const SET_EXECUTION_BATCH_DATE_TIME = "SET_EXECUTION_BATCH_DATE_TIME";
export const CLEAR_EXECUTION_BATCH_DATE_TIME = "CLEAR_EXECUTION_BATCH_DATE_TIME";
export const ADD_STEP_INFO = "ADD_STEP_INFO";
export const SET_REPORT_TYPE = "SET_REPORT_TYPE";
export const SHOW_CALENDAR_DIALOG = "SHOW_CALENDAR_DIALOG";
export const HIDE_CALENDAR_DIALOG = "HIDE_CALENDAR_DIALOG";
export const SET_SELECTED_LOG_NODE_ID = "SET_SELECTED_LOG_NODE_ID";
export const CLEAR_SELECTED_LOG_NODE_ID = "CLEAR_SELECTED_LOG_NODE_ID";
export const CLEAR_FLOW_EXECUTION_REPORTS = "CLEAR_FLOW_EXECUTION_REPORTS";
export const SET_CURRENT_EXECUTION_REPORT_SESSION_ID = "SET_CURRENT_EXECUTION_REPORT_SESSION_ID";
export const END_EXECUTION_REPORT = "END_EXECUTION_REPORT";
export const ADD_REPORT_STATE = "ADD_REPORT_STATE";
export const RESET_EXECUTION_REPORTS = "RESET_EXECUTION_REPORTS";
export const SET_EXECUTOR_SOCKET_DOWN = "SET_EXECUTOR_SOCKET_DOWN";

/***** SOCKET.IO *****/
export const START_CHANNEL = "START_CHANNEL";
export const STOP_CHANNEL = "STOP_CHANNEL";
export const CHANNEL_ON = "CHANNEL_ON";
export const CHANNEL_OFF = "CHANNEL_OFF";
export const SERVER_ON = "SERVER_ON";
export const SERVER_OFF = "SERVER_OFF";

/***** SETTINGS *****/
export const TOGGLE_MIN_MAP = "TOGGLE_MIN_MAP";
export const TOGGLE_CONTROLS = "TOGGLE_CONTROLS";
export const SET_DESIGNER_SETTINGS = "SET_DESIGNER_SETTINGS";
export const SET_VIEW_OPTIONS = "SET_VIEW_OPTIONS";
export const TOOGLE_CANVAS_DIRECTION = "TOOGLE_CANVAS_DIRECTION";
export const SHOW_TOOLBOX_DETAILS = "SHOW_TOOLBOX_DETAILS";
export const HIDE_TOOLBOX_DETAILS = "HIDE_TOOLBOX_DETAILS";
export const SET_TOOLBOX_SELECTED_MENU_ITEM = "SET_TOOLBOX_SELECTED_MENU_ITEM";
export const CLEAR_TOOLBOX_SELECTED_MENU_ITEM = "CLEAR_TOOLBOX_SELECTED_MENU_ITEM";

/***** COMPONENTS *****/
export const FETCH_COMPONENTS = "FETCH_COMPONENTS";
export const SET_COMPONENTS = "SET_COMPONENTS";
export const OPEN_REGISTER_COMPONENT_DIALOG = "OPEN_REGISTER_COMPONENT_DIALOG";
export const CLOSE_REGISTER_COMPONENT_DIALOG = "CLOSE_REGISTER_COMPONENT_DIALOG";
export const CREATE_COMPONENT = "CREATE_COMPONENT";
export const UPDATE_COMPONENT = "UPDATE_COMPONENT";
export const DELETE_COMPONENT = "DELETE_COMPONENT";
export const SET_SAVING_COMPONENT_FLAG_SUCCESS = "SET_SAVING_COMPONENT_FLAG_SUCCESS";
export const SET_SAVING_COMPONENT_FLAG_RESET = "SET_SAVING_COMPONENT_FLAG_RESET";
export const SET_SAVE_COMPONENT_FAILED = "SET_SAVE_COMPONENT_FAILED";
export const SET_SAVE_COMPONENT_FAILED_RESET = "SET_SAVE_COMPONENT_FAILED_RESET";
export const SET_DELETE_COMPONENT_FAILED = "SET_DELETE_COMPONENT_FAILED";
export const SET_DELETE_COMPONENT_FAILED_RESET = "SET_DELETE_COMPONENT_FAILED_RESET";
export const SET_DELETE_COMPONENT_SUCCESS = "SET_DELETE_COMPONENT_SUCCESS";
export const SET_DELETE_COMPONENT_SUCCESS_RESET = "SET_DELETE_COMPONENT_SUCCESS_RESET";
export const SET_UPDATED_COMPONENT = "SET_UPDATED_COMPONENT";
export const SET_COMPONENT_PROPS_PANEL_TITLE = "SET_COMPONENT_PROPS_PANEL_TITLE";
export const UPDATE_COMPONENT_PROPS_TAB = "UPDATE_COMPONENT_PROPS_TAB";

/***** COMPONENT GROUPS *****/
export const CREATE_USER_COMPONENT_GROUP = "CREATE_USER_COMPONENT_GROUP";
export const UPDATE_USER_COMPONENT_GROUP = "UPDATE_USER_COMPONENT_GROUP";
export const FETCH_USER_COMPONENT_GROUPS = "FETCH_USER_COMPONENT_GROUPS";
export const FETCH_COMPONENT_GROUP_COMPONENTS = "FETCH_COMPONENT_GROUP_COMPONENTS";
export const SET_USER_COMPONENT_GROUPS = "SET_USER_COMPONENT_GROUPS";
export const SET_COMPONENT_GROUP_COMPONENTS = "SET_COMPONENT_GROUP_COMPONENTS";
export const SET_ACTIVE_USER_COMPONENT_GROUPS = "SET_ACTIVE_USER_COMPONENT_GROUPS";
export const FETCH_ACTIVE_USER_COMPONENT_GROUPS = "FETCH_ACTIVE_USER_COMPONENT_GROUPS";
export const ADD_USER_COMPONENT_GROUP = "ADD_USER_COMPONENT_GROUP";
export const SET_SAVE_USER_COMPONENT_GROUP_FAILED = "SET_SAVE_USER_COMPONENT_GROUP_FAILED";
export const SET_SAVE_USER_COMPONENT_GROUP_FAILED_RESET = "SET_SAVE_USER_COMPONENT_GROUP_FAILED_RESET";
export const UPDATE_USER_COMPONENT_GROUPS_STATE = "UPDATE_USER_COMPONENT_GROUPS_STATE";
export const DELETE_USER_COMPONENT_GROUP = "DELETE_USER_COMPONENT_GROUP";
export const SET_DELETE_USER_COMPONENT_GROUP_SUCCESS = "SET_DELETE_USER_COMPONENT_GROUP_SUCCESS";
export const SET_DELETE_USER_COMPONENT_GROUP_SUCCESS_RESET = "SET_DELETE_USER_COMPONENT_GROUP_SUCCESS_RESET";
export const FETCH_TOOLBOX_DATA = "FETCH_TOOLBOX_DATA";

/***** CALENDAR *****/
export const FETCH_CALENDAR_EVENTS = "FETCH_CALENDAR_EVENTS";
export const FETCH_CALENDAR_FLOWS = "FETCH_CALENDAR_FLOWS";
export const FETCH_CALENDAR_EVENTS_BY_FLOW_ID = "FETCH_CALENDAR_EVENTS_BY_FLOW_ID";
export const SET_CALENDAR_EVENTS = "SET_CALENDAR_EVENTS";
export const SET_CALENDAR_FLOWS = "SET_CALENDAR_FLOWS";
export const PAUSE_SCHEDULE = "PAUSE_SCHEDULE";
export const RESUME_SCHEDULE = "RESUME_SCHEDULE";
export const CREATE_SCHEDULE = "CREATE_SCHEDULE";
export const CREATE_SCHEDULE_FROM_TRIGGER = "CREATE_SCHEDULE_FROM_TRIGGER";
export const UPDATE_SCHEDULE_FROM_TRIGGER = "UPDATE_SCHEDULE_FROM_TRIGGER";
export const UPDATE_SCHEDULE = "UPDATE_SCHEDULE";
export const DELETE_SCHEDULE = "DELETE_SCHEDULE";
export const SET_SAVE_SCHEDULE_SUCCESS = "SET_SAVE_SCHEDULE_SUCCESS";
export const SET_SAVE_SCHEDULE_SUCCESS_RESET = "SET_SAVE_SCHEDULE_SUCCESS_RESET";
export const SET_SAVE_SCHEDULE_FAILED = "SET_SAVE_SCHEDULE_FAILED";
export const SET_SAVE_SCHEDULE_FAILED_RESET = "SET_SAVE_SCHEDULE_FAILED_RESET";
export const UPDATE_SCHEDULE_DOCUMENTATION = "UPDATE_SCHEDULE_DOCUMENTATION";
export const FETCH_SHARED_SCHEDULES = "FETCH_SHARED_SCHEDULES";
export const SET_SHARED_SCHEDULES = "SET_SHARED_SCHEDULES";

/***** COMPONENT PROPERTIES PANEL *****/
export const OPEN_COMPONENT_PROPS_PANEL = "OPEN_COMPONENT_PROPS_PANEL";
export const HIDE_COMPONENT_PROPS_PANEL = "HIDE_COMPONENT_PROPS_PANEL";
export const EXPAND_COMPONENT_PROPS_PANEL = "EXPAND_COMPONENT_PROPS_PANEL";
export const COLLAPSE_COMPONENT_PROPS_PANEL = "COLLAPSE_COMPONENT_PROPS_PANEL";
export const OPEN_COMPONENT_PROPS_CONFIRMATION_DIALOG = "OPEN_COMPONENT_PROPS_CONFIRMATION_DIALOG";
export const CLOSE_COMPONENT_PROPS_CONFIRMATION_DIALOG = "CLOSE_COMPONENT_PROPS_CONFIRMATION_DIALOG";
export const SET_COMPONENT_PROPS_PANEL_FORM_ISDIRTY = "SET_COMPONENT_PROPS_PANEL_FORM_ISDIRTY";
export const SET_SELECTED_COMPONENT_PROPS_PANEL = "SET_SELECTED_COMPONENT_PROPS_PANEL";
export const SET_SELECTED_NODE = " SET_SELECTED_NODE";
export const SET_CURRENT_ACTION_FORM = "SET_CURRENT_ACTION_FORM";
export const OPEN_START_NODE_PANEL = "SET_SHOW_START_NODE_PANEL";
export const HIDE_START_NODE_PANEL = "HIDE_START_NODE_PANEL";
export const SET_TO_OPEN_NODE_TAB = "SET_TO_OPEN_NODE_TAB";
export const SET_RECENTLY_DELETED_BRANCH_NODE_ID = "SET_RECENTLY_DELETED_BRANCH_NODE_ID";

/***** USERS *****/
export const FETCH_USERS = "FETCH_USERS";
export const SET_USERS = "SET_USERS";

/***** CONTEXT *****/
export const OPEN_CONTEXT_PANEL = "OPEN_CONTEXT_PANEL";
export const HIDE_CONTEXT_PANEL = "HIDE_CONTEXT_PANEL";
export const ADD_STEP_TO_CONTEXT = "ADD_STEP_TO_CONTEXT";
export const UPDATE_STEP_CONTEXT_OUTPUT_DATA = "UPDATE_STEP_CONTEXT_OUTPUT_DATA";
export const REMOVE_STEP_FROM_CONTEXT = "REMOVE_STEP_FROM_CONTEXT";
export const ADD_CONTEXT_VARIABLE = "ADD_CONTEXT_VARIABLE";
export const DELETE_CONTEXT_VARIABLE = "DELETE_CONTEXT_VARIABLE";
export const UPDATE_CONTEXT_VARIABLE = "UPDATE_CONTEXT_VARIABLE";
export const SET_CONTEXT_VARIABLES = "SET_CONTEXT_VARIABLES";
export const SET_CONTEXT = "SET_CONTEXT";
export const SET_CONTEXT_CREDENTIALS_MANAGEMENT = "SET_CONTEXT_CREDENTIALS_MANAGEMENT";
export const ADD_CONTEXT_TRIGGER = "ADD_CONTEXT_TRIGGER";
export const UPDATE_CONTEXT_TRIGGER = "UPDATE_CONTEXT_TRIGGER";
export const DELETE_CONTEXT_TRIGGER = "DELETE_CONTEXT_TRIGGER";
export const TOGGLE_CONTEXT_TRIGGER = "TOGGLE_CONTEXT_TRIGGER";
export const SET_CONTEXT_FILTER_OPTIONS = "SET_CONTEXT_FILTER_OPTIONS";
export const CHANGE_CONTEXT_FILTER_OPTION = "CHANGE_CONTEXT_FILTER_OPTION";

/***** TENANT *****/
export const FETCH_TENANT = "FETCH_TENANT";
export const SET_TENANT = "SET_TENANT";

/***** TRIGGERS *****/
export const SET_IS_TITLEBAR_TRIGGER_LIST_OPEN = "SET_IS_TITLEBAR_TRIGGER_LIST_OPEN";
export const SET_IS_TITLEBAR_EXECUTE_TRIGGER_LIST_OPEN = "SET_IS_TITLEBAR_EXECUTE_TRIGGER_LIST_OPEN";
export const SET_EXECUTE_SELECTED_TRIGGER_ID = "SET_EXECUTE_SELECTED_TRIGGER_ID";
export const SHOW_TRIGGER_PROPERTIES_PANEL = "SHOW_TRIGGER_PROPERTIES_PANEL";
export const HIDE_TRIGGER_PROPERTIES_PANEL = "HIDE_TRIGGER_PROPERTIES_PANEL";
export const SET_SELECTED_TRIGGER = "SET_SELECTED_TRIGGER";
export const CLEAR_SELECTED_TRIGGER = "CLEAR_SELECTED_TRIGGER";
export const SET_FLOW_TRIGGERS = "SET_FLOW_TRIGGERS";
export const CLEAR_FLOW_TRIGGERS = "CLEAR_FLOW_TRIGGERS";
export const ADD_FLOW_TRIGGER = "ADD_FLOW_TRIGGER";
export const DELETE_FLOW_TRIGGER = "DELETE_FLOW_TRIGGER";
export const UPDATE_FLOW_TRIGGER = "UPDATE_FLOW_TRIGGER";
export const OPEN_TRIGGER_DELETE_DIALOG = "OPEN_TRIGGER_DELETE_DIALOG";
export const CLOSE_TRIGGER_DELETE_DIALOG = "CLOSE_TRIGGER_DELETE_DIALOG";
export const SET_TRIGGER_FOR_DELETE = "SET_TRIGGER_FOR_DELETE";
export const CLEAR_TRIGGER_FOR_DELETE = "CLEAR_TRIGGER_FOR_DELETE";
export const START_DRAG_TRIGGER = "START_DRAG_TRIGGER";
export const STOP_DRAG_TRIGGER = "STOP_DRAG_TRIGGER";
export const TOGGLE_TRIGGER = "TOGGLE_TRIGGER";
export const SET_SELECTED_SCHEDULE = "SET_SELECTED_SCHEDULE";

/***** FLEX LAYOUT *****/
export const SET_MODEL_LAYOUT = "SET_MODEL_LAYOUT";

/***** FLOW CONFIGURATION *****/
export const FETCH_FLOW_CONFIGURATION = "FETCH_FLOW_CONFIGURATION";
export const SET_FLOW_CONFIGURATION = "SET_FLOW_CONFIGURATION";
export const FETCH_SHARED_FLOW_CONFIGURATIONS = "FETCH_SHARED_FLOW_CONFIGURATIONS";
export const SET_SHARED_FLOW_CONFIGURATIONS = "SET_SHARED_FLOW_CONFIGURATIONS";
